module.exports = __webpack_public_path__ + "img/Vector310.fe524915.svg";